import Preferences from "../Components/Dashboard";


function PreferencePage() {
    return (
        <div className="preferencePage">
            <Preferences />
        </div>
    )
}

export default PreferencePage;